<template>
  <span>
    <i class="fa fa-circle font-sm" :class="suspiciousLevelColor(occurrence)"></i>&nbsp;
    <span v-if="occurrence.suspiciousScore >= 5">Alto</span>
    <span v-else-if="occurrence.suspiciousScore === 4">Médio alto</span>
    <span v-else-if="occurrence.suspiciousScore === 3">Médio</span>
    <span v-else-if="occurrence.suspiciousScore === 2">Médio baixo</span>
    <span v-else-if="occurrence.suspiciousScore === 1">Baixo</span>
    <span v-else>Inconclusivo</span>
  </span>
</template>

<script>
export default {
  name: 'OccurrenceSuspiciousScore',
  props: {
    occurrence: Object
  },
  methods: {
    suspiciousLevelColor (occurrence) {
      if (occurrence.suspiciousScore > 5) return 'text-danger'

      switch (occurrence.suspiciousScore) {
        case 5: return 'text-danger'
        case 4: return 'text-danger'
        case 3: return 'text-warning'
        case 2: return 'text-yellow'
        case 1: return 'text-info'
        default: return 'text-gray-400'
      }
    }
  }
}
</script>
